const TeamMember = ({ key, team }) => {
  return (
    <>
      <div key={key} className="card__two">
        <div className="position-relative card_inner">
          <div className="team-img">
            <img className="position-absolute" src={team.image} alt={team.name} />
          </div>
          <div className="bio position-absolute p-4 bottom-0 text-white w-100 d-none d-xl-block">
            <h6>{team.name}</h6>
            <p className="mb-0">{team.designation}</p>
          </div>
          <div className="card_wrapper text-white position-absolute w-100 top-0 bottom-0 start-0 d-none d-xl-block">
            <div className="card_wrapper_inner position-absolute p-4 bottom-0">
              <h6 className="mb-0">{team.name}</h6>
              <p className="fw-bold">{team.designation}</p>
              <p className="mb-0">{team.paragraph}</p>
            </div>
          </div>
        </div>
        <div className="mt-4 d-xl-none">
          <h6 className="mb-0">{team.name}</h6>
          <p className="fw-bold">{team.designation}</p>
          <p className="mb-0">{team.paragraph}</p>
        </div>
      </div>
    </>
  );
};

export default TeamMember;
